import { Controller } from "@hotwired/stimulus"
import { backStorageKey } from "./back_storage"

// Points a back link at the list URL remembered by back_save_controller. With
// nothing remembered the link keeps the href the template gave it, so it
// degrades to a plain link.
//
//   div data-controller="back-restore"
//     = link_to t("back"), accounts_path,
//       data: {back_restore_target: "link"}
export default class extends Controller {
  static targets = ["link"]
  static values = { key: String }

  connect() {
    const url = sessionStorage.getItem(backStorageKey(this))
    if (!url) return

    this.linkTargets.forEach((link) => {
      link.href = url
    })
  }
}
